<template>
  <div class="pcontent other">
    <div class="p_title add_leftPadding">
      <img
        :src="require('../../../assets/images/cLevelPool.png')"
        alt="县级师资库"
        width="302"
        height="59"
      />
    </div>
    <template v-for="(item, index) in provincelocalList" :key="index">
      <div class="sq">
        <span>{{ item.label }}</span>
      </div>
      <div class="choose_box add_leftPadding">
        <div
          @click="currentCourse(el)"
          class="course"
          :class="activeCourse === el.value ? 'courseBg_active' : 'courseBg'"
          v-for="el in item.children"
          :key="el.value"
        >
          {{ el.label }}
        </div>
      </div>
    </template>
  </div>
  <Modal v-model="isShow" footer-hide class-name="smodel">
    <div class="activelabel">
      <span class="activelabel_name">{{ activeLabel }}</span>
      &emsp;【师资预约电话: {{ extendText ? extendText : "暂无" }}】
    </div>
    <template v-if="teacherList.length > 0">
      <div class="mTeacher">
        <div class="m_item" v-for="(item, index) in teacherList" :key="index">
          <div class="text_white name">{{ item.realName }}</div>
          <div class="text_ph sex" :title="item.unitDuty">
            {{ item.unitDuty }}
          </div>
          <div class="dashed"></div>
          <!-- <div class="text_gh nr" :title="item.academicAchievements">
            {{ item.academicAchievements }}
          </div>
          <div class="dashed"></div>
          <div class="item_td">
            <div class="td_item">
              <span class="td_title jc_text">是否专家</span>
              <span class="text_gh jc_text">{{
                item.isExpert ? "是" : "否"
              }}</span>
            </div>
            <div class="td_item_center"></div>
            <div class="td_item">
              <span class="td_title jc_text">师资类别</span>
              <span class="text_gh jc_text">{{ item.typeList[0] }}</span>
            </div>
          </div> -->
          <div>
            <span class="td_title jc_text">师资类别: </span>
            <template v-if="item.typeList.length">
              <Tag
                v-for="(item, index) in item.typeList"
                :key="item"
                :color="index === 0 ? 'blue' : index === 1 ? 'red' : 'yellow'"
                >{{ item }}</Tag
              >
            </template>
          </div>
        </div>
      </div>
      <div class="page">
        <Page
          :total="total"
          show-elevator
          show-total
          :model-value="params.pageCurrent"
          :page-size="params.MaxResultCount"
          @on-prev="prev"
          @on-next="next"
          @on-change="pageChange"
        />
      </div>
    </template>
    <div class="empty" v-else>暂无数据</div>
  </Modal>
</template>

<script setup>
import { szkGet } from "../../../api/common.js";
import { ref, onMounted, defineProps } from "vue";
import { setDict, getCode } from "../../../utils/dict";
import { useStore } from "../../../store/index.js";
const store = useStore();
const courseList = ref([]); // 师资类别
const isShow = ref(false); // 是否显示弹框列表
const provincelocalList = ref([]); // 位置信息
const education = ref([]); // 教育字典
const activeCourse = ref();
const activeLabel = ref();
const extendText = ref(); // 联系电话
function currentCourse(item) {
  activeCourse.value = item.value;
  activeLabel.value = item.label;
  extendText.value = item.extendText;
  params.value.AreaName = item.value;
  params.value.SkipCount = 0;
  params.value.pageCurrent = 1;
  params.value.TeacherType = store.TeacherType;
  getTeacherList();
  isShow.value = true;
}
const teacherList = ref([]);
const params = ref({
  AreaName: "",
  TeacherType: store.TeacherType,
  MaxResultCount: 9,
  SkipCount: 0,
  TeacherClass: "3",
  pageCurrent: 1,
});
const total = ref(0);
function getTeacherList() {
  szkGet(params.value, "/services/app/TeacherLibaryService/IndexPageList").then(
    (res) => {
      if (res.items && res.items.length) {
        res.items.forEach((item) => {
          education.value.forEach((e) => {
            if (e.value == item.level) {
              item.xllevel = e.label;
            }
          });
          item.typeList = [];
          let list = item.lectureCategory
            ? item.lectureCategory.split(",")
            : [];
          list.forEach((ele) => {
            courseList.value.forEach((c) => {
              if (ele == c.value) {
                item.typeList.push(c.label);
              }
            });
          });
        });
      }
      teacherList.value = res.items;
      total.value = res.totalCount;
    }
  );
}
onMounted(async () => {
  // console.log('props.education::', props.education);
  // const data = await getCode('LectureCategory', 'AdminArea', 'Education');
  // provincelocalList.value = data['AdminArea'][0].children;
  // courseList.value = data['LectureCategory'];
  // education.value = data['Education'];
  if (window.localStorage.getItem("code")) {
    let data = JSON.parse(window.localStorage.getItem("code"));
    provincelocalList.value = data["AdminArea"][0].children;
    courseList.value = data["LectureCategory"];
    education.value = data["Education"];
  }

  // getTeacherList();
});
function prev(val) {
  params.value.pageCurrent = val;
  params.value.SkipCount = (val - 1) * params.value.MaxResultCount;
  getTeacherList();
}
function next(val) {
  params.value.pageCurrent = val;
  params.value.SkipCount = (val - 1) * params.value.MaxResultCount;
  getTeacherList();
}
function pageChange(val) {
  params.value.pageCurrent = val;
  params.value.SkipCount = (val - 1) * params.value.MaxResultCount;
  getTeacherList();
}
</script>

<style lang="scss" scoped>
.p_title {
  img {
    width: 302px;
    height: 59px;
  }
}
.sq {
  background: url("../../../assets/images/sj.png") no-repeat;
  background-size: 100% 100%;
  font-size: #931000;
  margin-top: 20px;
  font-weight: bold;
  width: 138px;
  height: 36px;
  color: #fff;
  line-height: 36px;
  text-align: center;
}
.other {
  padding-left: 0;
}
.add_leftPadding {
  margin-left: 20px;
}
</style>
